import { useQuery } from '@tallink/more-react-hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'

import { hasSerialTickets } from '../../selectors/selectors'
import ButtonBack from '../layout/ButtonBack/ButtonBack'
import Layout from '../layout/Layout'
import DeliveryDetails from '../Summary/DeliveryDetails/DeliveryDetails'
import Payment from './Payment/Payment'
import s from './PaymentAndDelivery.module.scss'

export default function PaymentAndDelivery() {
  const { t } = useTranslation()
  const serialTicketsLoaded = useSelector(hasSerialTickets)
  const location = useLocation()
  const backendError = useQuery('backendError')
  const shouldRedirectToMainPage = !serialTicketsLoaded || backendError

  useEffectOnce(() => {
    if (serialTicketsLoaded) {
      window.scrollTo(0, 0)
    }
  })

  return shouldRedirectToMainPage ? (
    <Redirect to={`/${location.search}`} />
  ) : (
    <Layout pageTitle={t('mainPage.title')}>
      <div className={s['back-button-container']}>
        <ButtonBack />
      </div>
      <DeliveryDetails />
      <Payment />
    </Layout>
  )
}
